import React from "react"
import { Box } from "@chakra-ui/react"
import { Control } from "react-hook-form"
import ColorSelect from "components/ReactHookForm/ColorSelect/ColorSelect"
import { WalletPassBuilderFormValues } from "./walletPassBuilderTypes"
import { PassBuilderFieldHeading, PlatformHint } from "./PassBuilderLayout"

type Props = {
  name: keyof WalletPassBuilderFormValues
  label: string
  platform?: PlatformHint
  control: Control<WalletPassBuilderFormValues>
}

const PassBuilderColorField = ({
  name, label, platform = "both", control,
}: Props) => (
  <Box>
    <PassBuilderFieldHeading title={label} platform={platform} />
    <ColorSelect name={name} control={control as any} compact />
  </Box>
)

export default PassBuilderColorField
